
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { Skeleton } from '@/components/ui/skeleton';

const AnnouncementBar = () => {
  const location = useLocation();
  const { data: settings, isLoading, isError } = useSiteSettings();

  // Only show announcement bar on homepage and shop page
  if (location.pathname !== '/' && location.pathname !== '/shop') {
    return null;
  }

  // Hide bar on error instead of showing skeleton forever
  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="bg-foreground text-primary-foreground text-center py-2.5 px-4 text-sm font-medium">
        <Skeleton className="h-5 w-1/2 mx-auto bg-primary/20" />
      </div>
    );
  }

  if (!settings?.announcement_text) {
    return null;
  }

  return (
    <div className="bg-foreground text-primary-foreground text-center py-2.5 px-4 text-sm font-medium">
      <p>
        {settings.announcement_text}{' '}
        {settings.announcement_link_text && settings.announcement_link_href && (
          <a href={settings.announcement_link_href} className="underline hover:opacity-80 transition-opacity">
            {settings.announcement_link_text}
          </a>
        )}
      </p>
    </div>
  );
};

export default AnnouncementBar;
